import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/objectWithoutPropertiesLoose';
import React from 'react';
import { a as addSpacingClasses, m as marginProps } from './spacing-d13ff368.js';
import { p as props } from './componentEl-33ff2aeb.js';
import 'prop-types';

function Divider(_ref) {
  let {
    componentEl: Component,
    margin
  } = _ref,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["componentEl", "margin"]);

  let cssClasses = ['st_divider'];
  cssClasses = addSpacingClasses({
    margin,
    cssClasses
  });
  return /*#__PURE__*/React.createElement(Component, _extends({
    role: "separator",
    className: cssClasses.join(' ')
  }, otherProps));
}

Divider.propTypes = {
  /** dom element or component to use for outermost wrapper */
  componentEl: props,

  /** margin for component, if any */
  margin: marginProps
};
Divider.defaultProps = {
  componentEl: 'hr',
  margin: null
};

export default Divider;
